export type StreamConnector = (url: string) => Promise<WebSocket>;

export function createStream(baseUrl: string): StreamConnector {
    return async (url: string) => {
        const protocol = window.location.protocol == 'https:' ? 'wss:' : 'ws:';
        const tmp = /^wss?:\/\//.test(baseUrl)
            ? baseUrl + url
            : `${protocol}//${window.location.host}${baseUrl}${url}`;
        return new WebSocket(tmp);
    };
}
